import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getIndependentSymbol, getPercentage, getTimeAgo, translate, translateNumber, translatePercentage } from "../../../helper";
import { ASSET_HOST_BASE_URL, otherParty, TOP_PARTY_COUNT, POPULAR_REGIONS_FEDERAL_2079, POPULAR_REGIONS_PROVINCIAL_2079 } from "../../../config";
import LangContext from "../../../contexts/LangContext";
import Tab from "../../common/Tab";
import { LoaderInner } from "../../common/Loader";
import "./index.css";

const PARTY_RANK = {
  NC: 0,
  RSP: 1,
  CPNUML: 2,
  NDP: 3,
  NKP: 4,
};

const getPartyRank = (code) => {
  const normalizedCode = String(code || "").toUpperCase();
  return Object.prototype.hasOwnProperty.call(PARTY_RANK, normalizedCode) ? PARTY_RANK[normalizedCode] : Number.POSITIVE_INFINITY;
};

const sortByPartyPriority = (candidates = []) =>
  
  candidates
    .map((candidate, index) => ({ candidate, index }))
    .sort((a, b) => {
      const rankA = getPartyRank(a.candidate.party);
      const rankB = getPartyRank(b.candidate.party);

      if (rankA !== rankB) return rankA - rankB;

      // For same priority party, prefer higher votes when available.
      const voteA = Number(a.candidate.vote);
      const voteB = Number(b.candidate.vote);
      if (!Number.isNaN(voteA) && !Number.isNaN(voteB) && voteA !== voteB) {
        return voteB - voteA;
      }

      // Stable fallback for all others.
      return a.index - b.index;
    })
    .map(({ candidate }) => candidate);

const HeavyWeight = (props) => {
  const { lang } = useContext(LangContext);
  const [dataToShow, setDataToShow] = useState(12);
  const { tab, data, provinces, parties } = props;
  const hwRegions = [];

  let heavyWeights = [];

  if (tab === "provincial") {
    heavyWeights = POPULAR_REGIONS_PROVINCIAL_2079.heavy_weights;
  } else {
    heavyWeights = POPULAR_REGIONS_FEDERAL_2079.heavy_weights;
  }

  data.provinces.forEach((prov) => {
    prov.districts.forEach((dist) => {
      dist.regions.forEach((reg) => {
        let regionFixed = 0;
        if (reg.rtype === "provincial") {
          regionFixed = 1;
        }
        const region_code = dist.id + "-" + parseFloat(reg.id).toFixed(regionFixed);
        const HeavyWeight = heavyWeights.find((pr) => pr.region === region_code);
        if (reg.rtype === tab && HeavyWeight) {
          reg.district_id = dist.id;
          reg.province_id = prov.id;
          reg.heavy_wt_info = HeavyWeight;
          hwRegions.push(reg);
        }
      });
    });
  });

  let regionData = [];
  regionData = hwRegions.map((region) => {
    if (!region.result) return [];
    let rData = JSON.parse(JSON.stringify(region));
    rData.total = rData.result.reduce((a, b) => a + b.vote, 0);
    if (!rData.result.find((r) => r.vote > 0)) {
      rData.result = rData.result.sort((a, b) => {
        if (b.name_en < a.name_en) return 1;
        else return -1;
      });
    }
    const elected = rData.result.find((a) => a.elected);
    const followings = rData.result.filter((a) => !a.elected).sort((a, b) => b.vote - a.vote);

    rData.result = elected ? [elected, ...followings] : [...followings];
    
    // rData.result = rData.result.sort((a,b) => b.vote - a.vote)
    rData.result = sortByPartyPriority(rData.result);
    rData.result = rData.result.sort((a,b) => b.vote - a.vote)
    // console.log(rData.result, 'candidates list ho yo ch')
    
    const heavyWeightPartyCode = String(region.heavy_wt_info.party || "").toUpperCase();
    const heavyWeight = rData.result.find((d) => String(d.party || "").toUpperCase() === heavyWeightPartyCode);
    rData.result = rData.result.filter((d) => String(d.party || "").toUpperCase() !== heavyWeightPartyCode);
    rData.result = heavyWeight ? [heavyWeight, ...rData.result] : [...rData.result];
    rData.result = rData.result.filter((a, b) => b < TOP_PARTY_COUNT);
    // console.log(rData.result, 'this is rochak chetra data')
    
    return rData;
  });

  let updatedAt = new Date("2022-11-20T23:59:59");
  regionData.forEach((r) => {
    if (r.result) {
      r.result.forEach((res) => {
        if (updatedAt < new Date(res.updated_at)) {
          updatedAt = new Date(res.updated_at);
        }
      });
    }
  });

  const eastToWesRegions = [];
  provinces.forEach((p) => {
    p.districts.forEach((d) => {
      d.regions.forEach((r) => {
        let regionFixed = 0;
        if (r.rtype === "provincial") {
          regionFixed = 1;
        }
        const region_code = d.id + "-" + parseFloat(r.id).toFixed(regionFixed);
        if (r.rtype === tab && heavyWeights.find((pr) => pr.region === region_code)) {
          r.province_id = p.id;
          r.district_id = d.id;
          r.region_code = region_code;
          r.dist_name_np = d.name_np;
          r.dist_name_en = d.name_en;
          eastToWesRegions.push(r);
        }
      });
    });
  });

  let wtBasedRegions = heavyWeights
    .map((reg) => {
      const region = eastToWesRegions.find((r) => r.region_code === reg.region);
      return region;
    })
    .filter((a) => a);

  const handleLoadMore = (el) => {
    if (dataToShow + 12 < heavyWeights.length) {
      setDataToShow(dataToShow + 12);
    }
    el.target.focus();
  };

  const handleLoadLess = (el) => {
    if (dataToShow > 12) {
      setDataToShow(dataToShow - 12);
    }
    el.target.focus();
  };

  useEffect(() => {
    if (!props.showmore) {
      setDataToShow(heavyWeights.length);
    }
  }, [heavyWeights.length, props.showmore]);

  return (
    <>
      {/* {props.showtab ? <Tab tab={tab} handleTabChange={props.handleTabChange} /> : ""} */}
      <section id="sh-hot-seat-summary" className="sh-summary-section">
        <div className="container">
          {!props.fetched ? (
            <LoaderInner />
          ) : (
            <div className={`sh-heavyweight-container ${!props.showmore ? "sh-heavyweight-page" : ""}`}>
              <div className="sh-heavyweight-header">
                <h3>{translate("heavy_weights_candidates", lang)}</h3>
                {props.showmore && (
                  <Link to={"/heavy-weights?type=" + tab + "&lang=" + lang} className="sh-heavyweight-view-all-btn">
                    सबै <span className="arrow">→</span>
                  </Link>
                )}
              </div>

              <div className="sh-heavyweight-grid">
                {wtBasedRegions
                  .filter((r, i) => i < dataToShow)
                  .map((reg, i) => {
                    const rData = regionData.find((r) => r && r.district_id === reg.district_id && r.id && r.id === reg.id);
                    // Show only top 3 candidates
                    const topCandidates = rData.result.slice(0, 3);
                    const isElected = topCandidates.filter(candidate => candidate.elected).length

                    const isCounting = topCandidates.filter(candidate => candidate.vote > 0).length
                    // console.log(isElected, 'iselected')
                    return (
                      <div key={i} className="sh-area-card">
                        <div className="sh-area-header">
                          <div className="sh-area-card-header-title">
                          <Link to={"/result/" + reg.province_id + "/" + reg.district_id + "/" + reg.id.toFixed(0) + "?type=" + tab + "&lang=" + lang} className="sh-area-name">
                            {reg["dist_name_" + lang]}: {reg["name_" + lang]}
                          </Link>
                          <span>
                            {isElected > 0 && isCounting > 0 && "(मतगणना समाप्त)"}
                            {isCounting > 0 && !isElected && "(मतगणना जारी)" }
                          </span>
                          </div>
                          <div className="sh-area-subtitle">
                            {translate("total_voter", lang)}: {translateNumber(reg.total_voter, lang)}
                          </div>
                        </div>

                        <div className="sh-candidates-section">
                          {topCandidates.map((d, j) => {
                            const party = parties.find((par) => par.code === d.party || (d.party.match(/I+\d/) && par.code === "I")) || otherParty;
                            let symbol = party.code.toUpperCase();
                            if (symbol === "I") {
                              symbol = getIndependentSymbol(reg.district_id, reg.id, d.name_en);
                            }
                            const gender = d.gender ? d.gender : "O";
                            
                            // Use candidatephoto if available, otherwise default URL
                            const candidateImageUrl = d.candidatephoto && d.candidatephoto.trim() !== "" 
                              ? d.candidatephoto 
                              : `https://result.election.gov.np/Images/Candidate/${d.candidateid}.jpg`;

                            return (
                              <div key={j} className="sh-candidate-item">
                                <div className="sh-candidate-item-wrapper">
                                  <div className="sh-candidate-photo-container">
                                    <Link to={"/candidates/profile/" + d.cid + "?lang=" + lang}>
                                      <img
                                        src={candidateImageUrl}
                                        alt={d["name_" + lang]}
                                        onError={({ currentTarget }) => {
                                          currentTarget.onerror = null;
                                          currentTarget.src = ASSET_HOST_BASE_URL + "/images/candidates/dummy-" + gender + ".jpg";
                                        }}
                                        className="sh-candidate-photo"
                                      />
                                    </Link>
                                    <Link to={"/candidates/" + party.code + "?lang=" + lang} className="sh-party-badge">
                                      <img
                                        src={ASSET_HOST_BASE_URL + "/images/parties/" + symbol + ".png"}
                                        alt={party.code}
                                        onError={({ currentTarget }) => {
                                          currentTarget.onerror = null;
                                          currentTarget.src = ASSET_HOST_BASE_URL + "/images/parties/O.png";
                                        }}
                                      />
                                    </Link>
                                  </div>
                                
                                  <div className="sh-candidate-details">
                                    <Link to={"/candidates/profile/" + d.cid + "?lang=" + lang} className="sh-candidate-name" title={d["name_" + lang]}>
                                      {d["name_" + lang]}
                                    </Link>
                                    
                                    <div className="sh-party-info">
                                      <Link to={"/candidates/" + party.code + "?lang=" + lang} title={party["name_" + lang]}>
                                        {party["short_name_" + lang] || party["name_" + lang]}
                                      </Link>
                                    </div>
                                    
                                    <div className="sh-candidate-meta">
                                      <span className="sh-meta-item">
                                        <span className="sh-meta-label">{translate("age", lang)}:</span>
                                        <span className="sh-meta-value">{translateNumber(d.age, lang)}</span>
                                      </span>
                                      <span className="sh-meta-item">
                                        <span className="sh-meta-label">{translate("gender", lang)}:</span>
                                        <span className="sh-meta-value">{translate(d.gender === "M" ? "male" : d.gender === "F" ? "female" : "other", lang)}</span>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="sh-vote-count-section">
                                   <div class="sh-banner-winner-section">
                                    {d.elected && rData.declared && <span className="sh-banner-winner">{ <img src={ "https://assets.deshsanchar.com/wp-content/uploads/2026/02/25194001/checklist2.png"} alt="winner" width="20px" height="20px" />}<span>{translate("elected", lang)}</span></span>}
                                    <span className="sh-winner data">
                                      <span>मत</span> {translateNumber(d.vote, lang)}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>

                        <div className="sh-card-footer">
                          <Link to={"/result/" + reg.province_id + "/" + reg.district_id + "/" + reg.id.toFixed(0) + "?type=" + tab + "&lang=" + lang} className="sh-view-details-link">
                            सबै विवरण →
                          </Link>
                        </div>
                      </div>
                    );
                  })}
              </div>

              {props.showmore && (
                <div className="sh-load-more-less text-center">
                  {dataToShow > 12 && (
                    <div className="sh-load-less" onClick={handleLoadLess}>
                      {translate("show_less", lang)}
                    </div>
                  )}
                  {dataToShow + 12 < heavyWeights.length && (
                    <div className="sh-load-more" onClick={handleLoadMore}>
                      {translate("load_more", lang)}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default HeavyWeight;
